"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnavStatsSection = void 0;
const ui_1 = require("@app/component/ui");
const data_grid_1 = require("@app/component/ui/data-grid");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const format_hours_1 = require("@app/util/format-hours");
const use_workspace_unavailability_categories_1 = require("@app/util/hooks/use-workspace-unavailability-categories");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const unavailability_context_1 = require("../unavailability-context");
const DETAILED_STATISTICS_CONTAINER = {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
};
const UnavStatsSection = () => {
    const { formControl } = (0, unavailability_context_1.useUnavailability)();
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const employees = (0, store_1.useRootSelector)((state) => state.employees);
    const categories = (0, use_workspace_unavailability_categories_1.getWorkspaceUnavailabilityCategories)(workspace);
    const userId = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'user' });
    const periodStart = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'period.start' });
    const periodEnd = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'period.end' });
    const categoryId = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'categoryId' });
    const contractId = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'contractId' });
    const currentEmployee = react_1.default.useMemo(() => ((0, util_1.isValue)(userId) ? employees[userId] : undefined), [userId]);
    const currentCategory = react_1.default.useMemo(() => categories.find((cat) => cat.id === categoryId), [categoryId]);
    const currentContract = react_1.default.useMemo(() => currentEmployee?.contracts.find((con) => con.id === contractId), [contractId]);
    const currentContractType = react_1.default.useMemo(() => workspace?.contractTypes?.find((con) => con.id === currentContract?.type)
        ?.name, [contractId]);
    const plannedMinutes = Math.round((0, moment_1.default)(periodEnd)
        .endOf('millisecond')
        .diff((0, moment_1.default)(periodStart).startOf('millisecond'), 'minutes', true));
    const workMinutes = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'workMinutes' });
    return (react_1.default.createElement("div", { style: DETAILED_STATISTICS_CONTAINER },
        react_1.default.createElement(ui_1.Text, { weight: 'bold' },
            (0, util_1.t)('DETAILED_STATISTICS'),
            " - ",
            currentEmployee?.name,
            ' ',
            (0, moment_1.default)(periodStart).format('DD. MM. YYYY'),
            " - ",
            currentCategory?.tag),
        react_1.default.createElement(data_grid_1.DataGrid, { columns: [
                {
                    cells: [
                        {
                            label: (0, util_1.t)('PLAN_HOURS'),
                            value: (0, format_hours_1.formatHours)(plannedMinutes / 60),
                        },
                        {
                            label: (0, util_1.t)('ATTENDANCE_HOURS'),
                            value: (0, util_1.isValue)(workMinutes) ? (0, format_hours_1.formatHours)(workMinutes / 60) : '-',
                        },
                        {
                            label: (0, util_1.t)('UNAV_TYPE'),
                            value: currentCategory?.name,
                        },
                        {
                            label: (0, util_1.t)('AGREEMENT'),
                            value: currentContractType,
                        },
                    ],
                },
            ] })));
};
exports.UnavStatsSection = UnavStatsSection;
